module.exports = __webpack_public_path__ + "static/media/ca.c2594215.svg";